import AbstractSurveyFormField from './AbstractSurveyFormField';

class SurveyRadioBoxesFormField extends AbstractSurveyFormField {
    options = [];
    other = null;
    otherInput = null;

    constructor(element, options) {
        super(element, { ...options, type: 'survey_radio_boxes' });
        const items = this.element.getElementsByClassName('question-option');
        for (let i = 0; i < items.length; i++) {
            this.options.push(items[i]);
        }

        const other = this.element.getElementsByClassName('survey-radio-boxes-other');
        if (other.length) {
            this.other = other[0];
            this.otherInput = this.other.getElementsByClassName('survey-radio-boxes-other-input')[0] ?? null;
        }

        this.options.forEach((option) => {
            option.addEventListener('click', () => {
                this.options.forEach((sibling) =>
                    sibling.classList.remove('active')
                );
                option.classList.add('active');
                this.syncOtherState();
                this.handleChanges(this);
            });
        });

        if (this.otherInput) {
            this.otherInput.addEventListener('input', this.handleChanges.bind(this));
        }

        this.syncOtherState();
    }

    syncOtherState() {
        if (!this.other) {
            return;
        }

        const otherOption = this.options.find((option) => option.dataset.isOther === '1');
        if (otherOption && otherOption.classList.contains('active')) {
            this.other.classList.add('active');
        } else {
            this.other.classList.remove('active');
        }
    }

    getValue() {
        let value = '';
        this.options.forEach((option) => {
            if (!option.classList.contains('active')) {
                return;
            }

            if (option.dataset.isOther === '1') {
                const otherValue = this.otherInput ? this.otherInput.value.trim() : '';
                value = otherValue.length ? `Other: ${otherValue}` : 'Other';
                return;
            }

            value = option.dataset.value;
        });

        return value;
    }
}

export default SurveyRadioBoxesFormField;